import React, { useEffect, useState } from "react";
import { profile } from "../data/mock";

const links = [
  { href: "#work", label: "Work" },
  { href: "#disciplines", label: "Experience" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [time, setTime] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const update = () => {
      try {
        const t = new Intl.DateTimeFormat("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
          timeZone: profile.timezone || "America/Los_Angeles",
        }).format(new Date());
        setTime(`${t} ${profile.timezoneLabel || "LA"}`);
      } catch {
        setTime("");
      }
    };
    update();
    const i = setInterval(update, 30 * 1000);
    return () => clearInterval(i);
  }, []);

  const handleNav = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,border] duration-300 ${
        scrolled
          ? "bg-[rgba(245,243,238,0.85)] backdrop-blur-md border-b border-[#d8d5cc]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <a
          href="#top"
          onClick={(e) => handleNav(e, "#top")}
          className="flex items-center gap-3 group"
        >
          <span className="inline-flex items-center justify-center w-9 h-9 border border-[#0d0d0d] text-[#0d0d0d] font-medium tracking-tight text-sm">
            {profile.monogram}
          </span>
          <span className="hidden md:flex flex-col leading-tight">
            <span className="text-[13px] font-medium text-[#0d0d0d] tracking-tight">
              {profile.name}
            </span>
            <span className="text-[11px] text-[#6b6b64] italic font-serif">
              Creative Producer / ACD
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleNav(e, l.href)}
              className="text-[13px] text-[#0d0d0d] tracking-tight relative py-1 hover:opacity-60 transition-opacity duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <span className="hidden md:inline text-[11px] tracking-[0.14em] uppercase text-[#6b6b64]">
            {time}
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
